"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/****************************************** IDs & CONFIG ******************************************/
exports.AS_TAG = "[AccountStore]";
var ACCOUNT_ID = exports.AS_TAG + " accountId";
var LAST_SYNC_TIMESTAMP = exports.AS_TAG + " lastSyncTimestamp";
var ACCOUNT_NAME = exports.AS_TAG + " name";
var ACCOUNT_EMAIL = exports.AS_TAG + " email";
var ACCOUNT_PHONE = exports.AS_TAG + " phone";
var ACCOUNT_MFA_ENABLED = exports.AS_TAG + " isMFAEnabled";
var ACCOUNT_PUSH_ENABLED = exports.AS_TAG + " isPushEnabled";
var ACCOUNT_PHONE_VERIFIED = exports.AS_TAG + " isPhoneVerified";
// Format to properly rehydrate moment dates (without thrown moment errors/warnings)
var MOMENT_STOREFORMAT = 'ddd MMM DD YYYY HH:mm:ss GMTZZ';
/************************************** THIRD-PARTY MODULES ***************************************/
var shared_1 = require("mad-utils/lib/shared");
var mobx_1 = require("mobx");
var moment_1 = __importDefault(require("moment"));
var localforage_1 = __importDefault(require("localforage"));
var axios_1 = __importDefault(require("axios"));
var keys = Object.keys, assign = Object.assign;
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var api_routes_1 = require("../../config/api-routes");
var dose_store_1 = require("./dose-store");
var token_store_1 = require("./token-store");
var broadcaster_1 = require("./broadcaster");
/******************************************** LOGGING *********************************************/
var shared_2 = require("mad-logs/lib/shared");
var log = shared_2.logFactory('store.ts', shared_2.Styles.joy);
/********************************************* EXPORT *********************************************/
var Store = /** @class */ (function () {
    /*******************************************************************/
    /********** INITIALIZERS **********/
    function Store(props) {
        var _this = this;
        /* IMMUTABLE DATA PROPERTIES (data from admin system) */
        this.cities = [];
        this.vaccines = [];
        this.diseases = [];
        this.diseaseConcepts = [];
        this.genericConcepts = [];
        this.tradeNameConcepts = [];
        this.doseGenerators = [];
        this.schedules = [];
        this.generatorCollections = [];
        this.phuIntegrations = [];
        this.phuConfigs = [];
        /* MUTABLE DATA PROPERTIES (record, transaction, dose, & page data) */
        this.records = [];
        this.transactions = [];
        /************************************** ACCOUNT DATA **************************************/
        this.password = '';
        this.lock = null;
        /*------------------------- ACCOUNT -------------------------*/
        this._account = null;
        /**
         * If possible pull all the account data you can from sessionStore, and use
         * it to return all data required to instantiate an Account
         */
        this.getAccountDataFromStorage = function () { return __awaiter(_this, void 0, void 0, function () {
            var self, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        self = this;
                        _a = {};
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_ID)];
                    case 1:
                        _a.accountId = (_e.sent());
                        _b = self.lastSyncTimestamp;
                        if (_b) return [3 /*break*/, 3];
                        _c = javelin_exports_1.ZonedDateTime.bind;
                        _d = moment_1.default;
                        return [4 /*yield*/, localforage_1.default.getItem(LAST_SYNC_TIMESTAMP)];
                    case 2:
                        _b = new (_c.apply(javelin_exports_1.ZonedDateTime, [void 0, _d.apply(void 0, [_e.sent(), MOMENT_STOREFORMAT])]))();
                        _e.label = 3;
                    case 3:
                        _a.lastSyncTimestamp = _b;
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_NAME)];
                    case 4:
                        _a.name = ((_e.sent()) || '');
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_EMAIL)];
                    case 5:
                        _a.email = ((_e.sent()) || '');
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_PHONE)];
                    case 6:
                        _a.phone = ((_e.sent()) || '');
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_PUSH_ENABLED)];
                    case 7:
                        _a.isPushEnabled = (_e.sent());
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_MFA_ENABLED)];
                    case 8:
                        _a.isMFAEnabled = (_e.sent());
                        return [4 /*yield*/, localforage_1.default.getItem(ACCOUNT_PHONE_VERIFIED)];
                    case 9: return [2 /*return*/, (_a.isPhoneVerified = (_e.sent()),
                            _a)];
                }
            });
        }); };
        /*-----------------------------------------------------------*/
        /*------------------ TOKEN STORE DELEGATION ------------------*/
        /**
         * Set the access token
         */
        this.setToken = function (token) { return _this.tokenStore.setToken(token); };
        /**
         * Delete the auth accessToken (should lock user out of app)
         */
        this.deleteToken = function () { return _this.tokenStore.deleteToken(); };
        /*------------------------------------------------------------*/
        /************************************ END ACCOUNT DATA ************************************/
        this.currentRecordIdx = 0;
        /************************ lastSyncTimestamp ************************/
        this._lastSyncTimestamp = null;
        /**
         * Hydrate props (grab from hydrators)
         * Adds all given props to this object
         */
        this.hydrate = mobx_1.action(function (props) {
            var store = assign(_this, props);
            keys(store).forEach(function (key) { return (_this[key] = store[key]); });
            return _this;
        });
        /********** ACTIONS **********/
        /**
         * Store new city into cities array if it does not already exist
         * Used to dynamically create cities list, reducing initial load time
         */
        this.addCity = mobx_1.action(function (city) {
            var cityIndex = _this.cities.findIndex(function (obj) { return obj.cityId === city.cityId; });
            if (cityIndex < 0)
                _this.cities.push(city);
        });
        /**
         * Fetch city object for given id and add to cities array
         * Used to dynamically create cities list, reducing initial load time
         * Also returns Promise containing the current city
         */
        this.fetchCity = mobx_1.action(function (cityId) {
            return axios_1.default
                .get(api_routes_1.apiRoutes.cities.url + "/" + cityId, { withCredentials: false })
                .then(function (_a) {
                var data = _a.data;
                var _b = data.entity, id = _b.cityId, n = _b.n, r = _b.r, c = _b.c, o = _b.o, a = _b.a;
                var newCity = new javelin_exports_1.City(id, n, r, c, o, a);
                _this.addCity(newCity);
                return newCity;
            })
                .catch(function (err) { return log.error("Unable to fetch city from admin system", err); });
        });
        /**
         * Store new record if record w/ given ID not already present
         * @return {RecordInstance[]} All stored records
         */
        this.addOrUpdateRecord = mobx_1.action(function (record) {
            log.info('addOrUpdateRecord :: record:', record);
            // Only store given record if record w/ given ID not already found in records
            var matchIdx = _this.records.findIndex(function (rec) { return rec.recordId === record.recordId; });
            if (shared_1.isInt(matchIdx) && matchIdx !== -1) {
                _this.records[matchIdx] = record;
            }
            else {
                _this.records.push(record);
            }
            // Return all stored records
            log.info("addOrUpdateRecord: this.records.peek() at end:", _this.records.peek());
            return _this.records;
        });
        /**
         * Add a transaction or transactions to the list of transactions to perform
         */
        this.addTransactions = mobx_1.action(function (transactions) {
            // prettier-ignore
            log.info("Store#addTransactions :: transactions:", transactions, "this.transactions:", _this.transactions);
            // Ensure we're dealing with an array
            var cleanTransactions = Array.isArray(transactions) ? transactions : [transactions];
            // Add each transaction to the store's transactions
            for (var _i = 0, cleanTransactions_1 = cleanTransactions; _i < cleanTransactions_1.length; _i++) {
                var trans = cleanTransactions_1[_i];
                _this.transactions.push(trans);
            }
        });
        /**** Transactions ****/
        /**
         * Get all transactions with the matching record ID
         * @param {string} recordId Record ID to check the transactions for
         * @return {TransactionInstance[]} All transactions w/ given recordId field
         */
        this.getTransactionsByRecordId = function (recordId) {
            return _this.transactions.filter(function (transaction) { return transaction.recordId === recordId; });
        };
        /********** DELETERS **********/
        this.deleteTransaction = mobx_1.action(function (transaction) {
            var res = _this.transactions.remove(transaction);
            // prettier-ignore
            log.verbose("Store#deleteTransaction :: [AFTER DELETE] transaction:", transaction, "this.transactions:", _this.transactions, "this.transactions.length:", _this.transactions.length);
            return res;
        });
        this.deleteRecord = mobx_1.action(function (record) { return _this.records.remove(record); });
        this.deleteLock = mobx_1.action(function () { return (_this.lock = null); });
        this.deletePassword = mobx_1.action(function () { return (_this.password = ''); });
        this.doseStore = dose_store_1.doseStoreFactory(this);
        this.jvlnsBroadcaster = broadcaster_1.Broadcaster.new();
        this.tokenStore = token_store_1.TokenStore.new();
        // Bind 'this' to methods
        keys(this).forEach(function (key) { return typeof _this[key] === 'function' && _this[key].bind(_this); });
        log.silly('Store#constructor :: this (on exit):', this);
    }
    Object.defineProperty(Store.prototype, "account", {
        get: function () {
            return this._account;
        },
        set: function (accountInstance) {
            this._account = accountInstance;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * From data object: Create Acccount instance & add to store
     * Also add lastSyncTimestamp from data object to store
     * @return {AccountInstance} created from data object
     */
    Store.prototype.setAccount = function (obj) {
        var account = new javelin_exports_1.Account(obj.accountId, obj.lastSyncTimestamp, obj.name, obj.email, obj.phone, obj.isPushEnabled, obj.isMFAEnabled, obj.isPhoneVerified);
        log.info("Store#setAccount :: account:", account);
        this.lastSyncTimestamp = obj.lastSyncTimestamp;
        this.account = account;
        return this.account;
    };
    /***** INITIALIZE ACCOUNT *****/
    /**
     * Asynchonous initialization, including loading from localforage data
     */
    Store.prototype.initAsync = function () {
        var _this = this;
        // Initialize account
        return Promise.all([
            this.getAccountDataFromStorage().then(mobx_1.action(function (data) {
                _this._account = data;
                return data;
            })),
            this.tokenStore.initialTokenSet(),
        ]);
    };
    Object.defineProperty(Store.prototype, "token", {
        /**
         * Return access token prefixed with 'accessToken=' for use in Cookie headers
         */
        get: function () {
            return this.tokenStore.token;
        },
        /**
         * Set the accessToken for authentication
         */
        set: function (tkn) {
            this.tokenStore.setToken(tkn);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "lastSyncTimestamp", {
        get: function () {
            return this._lastSyncTimestamp;
        },
        /* @action <<-- Set by MobX under-the-hood */
        set: function (lastSyncTimestamp) {
            var _this = this;
            this._lastSyncTimestamp = lastSyncTimestamp;
            (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localforage_1.default.setItem(LAST_SYNC_TIMESTAMP, lastSyncTimestamp.toString() || '')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            }); }); })();
        },
        enumerable: true,
        configurable: true
    });
    /********** MUTABLE PROP GETTERS **********/
    /**
     * @param {string} recordId Return record with this ID
     * @return {RecordInstance} Record with the matching ID (or null if none found)
     */
    Store.prototype.getRecordById = function (recordId) {
        return this.records.find(function (record) { return record.recordId === recordId; });
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "cities", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "vaccines", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "diseases", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "diseaseConcepts", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "genericConcepts", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "tradeNameConcepts", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "doseGenerators", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "schedules", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "generatorCollections", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "phuIntegrations", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "phuConfigs", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "records", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "transactions", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Store.prototype, "password", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], Store.prototype, "lock", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Store.prototype, "_account", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Object)
    ], Store.prototype, "setAccount", null);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", javelin_exports_1.ZonedDateTime)
    ], Store.prototype, "_lastSyncTimestamp", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", javelin_exports_1.ZonedDateTime),
        __metadata("design:paramtypes", [javelin_exports_1.ZonedDateTime])
    ], Store.prototype, "lastSyncTimestamp", null);
    return Store;
}());
exports.Store = Store;
/***************************************** FACTORY EXPORT *****************************************/
/**
 * @export store
 * Store factory
 * Immediately build and return store data
 */
exports.store = mobx_1.runInAction(function () { return new Store(); });
log.info("buildStore :: store:", exports.store);
global['__JVLNS_INNER_DATA_STORE__'] = exports.store;
//# sourceMappingURL=store.js.map